import React from "react";
const SvgDsChevron24 = props => (
  <svg fill="none" viewBox="0 0 25 24" {...props}>
    <path
      fill="#505A65"
      fillRule="evenodd"
      d="M5.97 9.47a.75.75 0 011.06 0l5.47 5.47 5.47-5.47a.75.75 0 111.06 1.06l-6 6a.75.75 0 01-1.06 0l-6-6a.75.75 0 010-1.06z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsChevron24;
